import React from 'react';
import { Target, Feather, Shield, Gauge } from 'lucide-react';

const BenefitsSection = () => {
  return (
    <section id="why-aerogel" className="why-section section-padding bg-gradient-subtle">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="section-header text-center mb-16">
          <h2 className="section-title">Why Aerogel?</h2>
          <div className="title-underline" />
          <p className="section-subtitle mt-6">Compared to Conventional Materials</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="benefit-card">
            <div className="benefit-icon-wrapper">
              <Target className="w-10 h-10" />
            </div>
            <h3 className="benefit-title">5–10× Better Insulation</h3>
            <p className="benefit-description">Superior performance compared to traditional materials</p>
          </div>

          <div className="benefit-card">
            <div className="benefit-icon-wrapper">
              <Feather className="w-10 h-10" />
            </div>
            <h3 className="benefit-title">Significant Weight Reduction</h3>
            <p className="benefit-description">Ultra-lightweight solutions for enhanced efficiency</p>
          </div>

          <div className="benefit-card">
            <div className="benefit-icon-wrapper">
              <Shield className="w-10 h-10" />
            </div>
            <h3 className="benefit-title">Improved Safety Margins</h3>
            <p className="benefit-description">Enhanced protection in high-risk thermal environments</p>
          </div>

          <div className="benefit-card">
            <div className="benefit-icon-wrapper">
              <Gauge className="w-10 h-10" />
            </div>
            <h3 className="benefit-title">Compact System Design</h3>
            <p className="benefit-description">Enables efficient use of space in constrained applications</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
